// App.js
import './App.css';
import React, { useEffect, useState } from 'react';
import HomePage from './componenet/page/HomePage';
import Loader from './componenet/loader/Loader';
import { Routes, Route } from 'react-router-dom';
import ViewAll from './componenet/ViewAll/ViewAll';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="app overflow-x-hidden ">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/project" element={<ViewAll />} />
          </Routes>
        </div>
      )}
    </>
  );
}

export default App;
